/* AD speed 10-24: product cards no longer inline full product JSON (media+variants).
   On the first swatch click in a card, fetch /products/<handle>.js once, fill the card's
   data-json-product template attribute, then replay the click so Ella's ColorSwatch
   (global.js) updates price/link exactly as before. Quick-add is unaffected (it fetches
   ?view=quick_add itself). Undo: see build/UNDO.md. */
(function () {
  if (window.__adCardJsonLazy) return;
  window.__adCardJsonLazy = true;
  var cache = {};
  function root() { return (window.Shopify && Shopify.routes && Shopify.routes.root) || '/'; }
  function getJson(handle) {
    if (!cache[handle]) {
      cache[handle] = fetch(root() + 'products/' + encodeURIComponent(handle) + '.js', { credentials: 'same-origin' })
        .then(function (r) { if (!r.ok) throw new Error(r.status); return r.json(); })
        .catch(function (e) { delete cache[handle]; throw e; });
    }
    return cache[handle];
  }
  document.addEventListener('click', function (e) {
    var t = e.target;
    if (!t || !t.closest) return;
    var sw = t.closest('color-swatch .swatch-item [data-variant-id]');
    if (!sw) return;
    var card = sw.closest('.card-wrapper');
    if (!card) return;
    var tpl = card.querySelector('template');
    if (!tpl || !tpl.content) return;
    var div = tpl.content.querySelector('[data-json-product]');
    if (!div) return;
    var data;
    try { data = JSON.parse(div.getAttribute('data-json-product')); } catch (_) { return; }
    if (data.variants || !data.handle) return;
    e.stopImmediatePropagation();
    e.preventDefault();
    getJson(data.handle).then(function (p) {
      div.setAttribute('data-json-product', JSON.stringify({ id: p.id, handle: p.handle, media: p.media || [], variants: p.variants || [] }));
      sw.dispatchEvent(new MouseEvent('click', { bubbles: true, cancelable: true }));
    }).catch(function () {
      var a = card.querySelector('a[href*="/products/"]');
      if (a) window.location.href = a.href;
    });
  }, true);
})();
